import React from 'react';
import { QuoteIcon } from 'lucide-react';
interface TestimonialCardProps {
  image: string;
  name: string;
  detail: string;
  quote: string;
  children: React.ReactNode;
}
export function TestimonialCard({
  image,
  name,
  detail,
  quote,
  children
}: TestimonialCardProps) {
  return <div className="my-8 overflow-hidden rounded-lg border border-ink/10 bg-white shadow-sm" data-id="element-348">
      <div className="flex flex-col gap-4 p-5 sm:flex-row sm:items-start" data-id="element-349">
        <img src={image} alt={`Portrait of ${name}`} className="h-20 w-20 flex-shrink-0 rounded-full object-cover ring-2 ring-rust/30" data-id="element-350" />
        <div data-id="element-351">
          <p className="font-display text-xl font-bold text-ink" data-id="element-352">{name}</p>
          <p className="mb-3 text-base text-ink-soft" data-id="element-353">{detail}</p>
          <QuoteIcon className="mb-1 h-5 w-5 text-rust" data-id="element-354" />
          <p className="font-serif text-lg italic leading-relaxed text-rust" data-id="element-355">
            “{quote}”
          </p>
        </div>
      </div>
      <div className="article-body border-t border-ink/10 px-5 py-4 font-serif text-[19px] text-ink" data-id="element-356">
        {children}
      </div>
    </div>;
}